import { PROCEDURE_STATUSES, PROCEDURE_STEPS } from 'containers/data-structure';
import { get } from 'lodash';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { IJudgementAdd } from 'containers/LawyerLegalProceedingsPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export const formatDecision = (
  status: string,
  claimId: number,
  judgementAdd: {} | IJudgementAdd,
  rejectionReason: null | string = null,
  code_lawyer: any,
  toUpdate: boolean,
) => {
  return {
    step: PROCEDURE_STEPS.JUDGEMENT_ADD,
    claimId,
    status: toUpdate ? get(judgementAdd, 'status') : status,
    id: get(judgementAdd, 'id'),
    rejectionReason,
    feeNote: {
      step: PROCEDURE_STEPS.JUDGEMENT_ADD,
      codeIntervenant: code_lawyer,
    },
    fflipFeeNote: true,
    username: currentUserStorage.get().username,
  };
};

export const shouldDisplayAddDecisionMenu = (status: string): boolean =>
  status === PROCEDURE_STATUSES.PENDING ||
  (featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
    status === PROCEDURE_STATUSES.TO_EDIT);
